import Message from 'owa-service/lib/contract/Message';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';

export default function isInJunkFolder(message: Message): boolean {
    return doesFolderIdEqualName(message.ParentFolderId.Id, 'junkemail');
}
